import { useCartItemToDelete } from '@/features/pos/components/Cart/hooks/useCartItemToDelete'
import { usePortal } from '@/features/pos/components/Cart/parts/CartItemDeleteConfirmationModal/contexts/Portal'
import { useConfirm } from '@/features/pos/components/Cart/parts/CartItemDeleteConfirmationModal/hooks/useConfirm'
import { unsetCartItemToDeleteId } from '@/features/pos/components/Cart/utils/cart-item-to-delete-id'
import ActionConfirmationModal from '@/features/pos/components/OrderFinalization/parts/ActionConfirmationModal'
import { useCloseOnPosModeChange } from '@/features/pos/hooks/useCloseOnPosModeChange'
import { FC, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

const CartItemDeleteConfirmationModal: FC = () => {
    const cartItemToDelete = useCartItemToDelete()

    const { t } = useTranslation()

    const handleConfirm = useConfirm()

    const MemoizedCartItemDeleteConfirmationModal = useMemo(
        () => (
            <ActionConfirmationModal
                action={t('pos.orderFinalization.cart.confirmDeleteItemMessage')}
                onConfirm={handleConfirm}
                onCancel={unsetCartItemToDeleteId}
            />
        ),
        [t, handleConfirm]
    )

    usePortal(!!cartItemToDelete, MemoizedCartItemDeleteConfirmationModal)

    useCloseOnPosModeChange(unsetCartItemToDeleteId)

    return null
}

export default CartItemDeleteConfirmationModal
